<div class="card" [ngClass]="cardClass">
	<div class="card-header" *ngIf="title">
		<h5>{{ title }}</h5>
		<span *ngIf="!classHeader">{{ headerContent }}</span>
		<span *ngIf="classHeader">
			<ng-content select=".code-header"></ng-content>
		</span>
		<div class="card-header-right">
			<i class="icofont icofont-rounded-down" cardToggleEvent (click)="toggleCard($event)"></i>
			<i class="icofont icofont-refresh" cardRefresh *ngIf="showRefresh"></i>
			<i class="icofont icofont-close-circled" (click)="closeCard($event)" *ngIf="showClose"></i>
		</div>
	</div>

	<div>
		<div class="card-body" [ngClass]="blockClass">
			<ng-content></ng-content>
		</div>
	</div>
</div>
